module.exports = __webpack_public_path__ + "img/front neck drop.224c7a32.png";